import { normalizarBienestar } from './bienestarFichaUtils';

export const PERFIL_BIENESTAR = Object.freeze({
    ADMIN: 'Per_Adm',
    GESTOR: 'Per_Bien_Gest',
    PSICOLOGO: 'Per_Bien_Ps',
});

const PERFILES_ADMIN_GESTOR = new Set([
    PERFIL_BIENESTAR.ADMIN,
    PERFIL_BIENESTAR.GESTOR,
]);

const PERFILES_PSICOLOGO = new Set([
    PERFIL_BIENESTAR.PSICOLOGO,
]);

const obtenerCodigoPerfil = (usuario) =>
    String(usuario?.perfil?.codigo || '').trim();

export const obtenerProfesionalAsignadoId = (origen) => {
    if (!origen) return null;
    const datos = normalizarBienestar(origen);
    if (!datos) return null;
    const candidato =
        datos?.profesional_asignado
        || datos?.detalle_agendamiento?.profesional_asignado
        || null;
    if (!candidato || typeof candidato !== 'object') return null;
    const id = candidato.id ?? candidato.pk ?? null;
    return id != null ? Number(id) : null;
};

export const usuarioEsProfesionalAsignado = (usuario, solicitud) => {
    const usuarioId = usuario?.id;
    const profesionalId = obtenerProfesionalAsignadoId(solicitud);
    if (!usuarioId || profesionalId == null) return false;
    return Number(usuarioId) === profesionalId;
};

export const usuarioEsAdminOGestor = (usuario) =>
    PERFILES_ADMIN_GESTOR.has(obtenerCodigoPerfil(usuario));

export const usuarioEsPsicologo = (usuario) =>
    PERFILES_PSICOLOGO.has(obtenerCodigoPerfil(usuario));

/**
 * Validación centralizada de acceso a contenido sensible (detalle, fichas,
 * adjuntos, historial, formatos, etc.).
 *
 * Devuelve `true` si el usuario puede ver la información asociada a la
 * solicitud entregada y `false` cuando debe bloquearse y mostrar el
 * mensaje correspondiente.
 *
 * @param {object} args
 * @param {object} args.usuario             Usuario autenticado (state.redGlobal.usuario)
 * @param {object} args.solicitud           Solicitud / bienestar (cualquier forma soportada)
 * @param {boolean} [args.esVistaEstudiante]
 * @returns {boolean}
 */
export const puedeVerContenidoBienestar = ({ usuario, solicitud, esVistaEstudiante = false } = {}) => {
    if (esVistaEstudiante === true) return true;
    if (usuarioEsAdminOGestor(usuario)) return true;
    if (usuarioEsPsicologo(usuario)) {
        return usuarioEsProfesionalAsignado(usuario, solicitud);
    }
    return false;
};

/**
 * Mensaje estándar para el caso "profesional no asignado" (psicólogos que
 * no son el profesional actual de la solicitud). Se reutiliza para
 * mantener consistencia visual y mensajería en todo el módulo.
 */
export const MENSAJE_SIN_PERMISO_PROFESIONAL = (
    'No tienes permisos para visualizar esta información. '
    + 'Si necesitas acceder a esta solicitud, comunícate con el administrador '
    + 'o coordinador del módulo para solicitar la asignación.'
);
